<div class="notes">
  <div class="notes__header">
    <span *ngIf="headerNote.length > 0">{{ headerNote }} <span *ngIf="isFieldRequired()" class="required notes-margin-l-0"> *</span></span>
    <span class="padding-l-0" *ngIf="subheaderNote.length > 0">{{ subheaderNote }}</span>
  </div>
  <div class="notes__text">
    <textarea
      #textareaRef
      [id]="identifier"
      matInput
      [maxlength]="maxLength"
      [placeholder]="placeHolder"
      [(ngModel)]="fieldValue"
      [disabled]="disabled"
      [required]="isFieldRequired()"
      [class.notes__textarea--error]="hasValidationError()"
      (change)="onChange($event)"
      (keyup)="onChange($event)"
      (blur)="onBlur()">
    </textarea>
    <div class="notes__footer" *ngIf="displayFooter || hasValidationError()">
      <span>
        <b i18n>Characters:</b> {{ fieldValue.length }}<b class="notes__validation-error"  *ngIf="hasValidationError()"> {{ getValidationError() }}</b>
        <ng-container *ngIf="displayLines"><b i18n>Lines:</b> {{ getLines() }}</ng-container>
      </span>
    </div>
  </div>
</div>
